import React, { useEffect } from "react";
import AddTeamMemberProfileForm from "./AddTeamMemberProfileForm";
import { Profile } from "./AddTeamMemberProfileForm";
import { buildApiUrl } from "../utils/apiConfig";
import { getUserId } from "../utils/auth";
import "../styles/add-team-member-modal.css";

type Props = {
    open: boolean;
    onClose: () => void;
    onSaved?: (saved: Profile) => void;
    initial?: Partial<Profile> & { id?: string | number };
    userId?: string;
    loadUrl?: string;
    saveUrl?: string;
};

export default function AddTeamMemberModal({
    open,
    onClose,
    onSaved,
    initial,
    userId,
    loadUrl = buildApiUrl("api/company/members/add/view"),
    saveUrl
}: Props) {
    // Close modal on Escape key
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => (open && e.key === "Escape" ? onClose() : undefined);
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open) return null;

    const handleSaved = (saved: Profile) => {
        onSaved?.(saved);
        onClose();
    };

    // Use the in-memory-backed id rather than reading localStorage.loggedInUserId
    // directly, which can be missing and yield a saveUrl like api/company/member/null.
    const currentUserId = getUserId();

    return (
        <div className="team-modal" role="dialog" aria-modal="true" aria-labelledby="team-modal-title">
            <div className="team-modal-card">
                <button className="team-modal-close" aria-label="Close" onClick={onClose}>×</button>
                <div className="team-modal-content">
                    <AddTeamMemberProfileForm
                        loadUrl={loadUrl}
                        saveUrl={saveUrl || buildApiUrl(`api/company/member/${currentUserId}`)}
                        onSaved={handleSaved}
                        onClose={onClose}
                    />
                </div>
            </div>
        </div>
    );
}
